export const TRANSACTION_DETAIL_REQUESTING =
	'transaction/TRANSACTION_DETAIL_REQUESTING';
export const TRANSACTION_DETAIL_SUCCESS =
	'transaction/TRANSACTION_DETAIL_SUCCESS';
export const TRANSACTION_DETAIL_ERROR = 'transaction/TRANSACTION_DETAIL_ERROR';

export const CASHBACK_DETAIL_REQUESTING =
	'transaction/CASHBACK_DETAIL_REQUESTING';
export const CASHBACK_DETAIL_SUCCESS = 'transaction/CASHBACK_DETAIL_SUCCESS';
export const CASHBACK_DETAIL_ERROR = 'transaction/CASHBACK_DETAIL_ERROR';

export const REFUND_TRANSACTION_REQUESTING =
	'trasactions/REFUND_TRANSACTION_REQUESTING';
export const REFUND_TRANSACTION_SUCCESS =
	'trasactions/REFUND_TRANSACTION_SUCCESS';
export const REFUND_TRANSACTION_ERROR = 'trasactions/REFUND_TRANSACTION_ERROR';
